var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-row",
        {
          staticClass: "mt-8",
          attrs: { align: "center", justify: "space-around" },
        },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                { attrs: { outlined: "", elevation: "2" } },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
                      _vm._v(" "),
                      _c("v-spacer"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.subscriptionCancelled
                    ? _c(
                        "div",
                        [
                          _vm.subscription &&
                          _vm.subscription.scheduleDowngrade &&
                          _vm.downgradePlan
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "mt-2",
                                  attrs: {
                                    value: _vm.hasScheduledDowngrade,
                                    dense: "",
                                    border: "left",
                                    type: "warning",
                                    color: "secondary",
                                    dismissible: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            This subscription is scheduled to "
                                  ),
                                  _c("strong", [_vm._v("downgrade")]),
                                  _vm._v(
                                    ". In order to update this subscription please "
                                  ),
                                  _c("strong", [_vm._v("Undo downgrade")]),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.hasScheduledDowngrade
                            ? _c(
                                "v-alert",
                                {
                                  attrs: {
                                    value: _vm.subscriptionCancelled,
                                    dense: "",
                                    border: "left",
                                    type: "warning",
                                    color: "secondary",
                                    dismissible: "",
                                  },
                                },
                                [
                                  _vm._v("\n            This subscription is "),
                                  _c("strong", [_vm._v("NOT")]),
                                  _vm._v(" schedule to renew\n          "),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "7", lg: "7", xl: "7" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { flat: "" } },
                            [
                              _c("v-divider", { staticClass: "mt-n2" }),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                { staticClass: "ml-2" },
                                [
                                  _vm.availablePlans.length > 0
                                    ? _c("v-col", { attrs: { cols: "6" } }, [
                                        _vm._v(
                                          "\n                  Add Plans\n                  "
                                        ),
                                        _c(
                                          "span",
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass: "mx-2",
                                                attrs: {
                                                  depressed: "",
                                                  fab: "",
                                                  "x-small": "",
                                                  color: "primary",
                                                  disabled:
                                                    _vm.pleaseWait ||
                                                    _vm.subscriptionCancelled,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.plansDialog = true
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  { attrs: { dark: "" } },
                                                  [
                                                    _vm._v(
                                                      "\n                        mdi-plus\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "5" } }),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "1" } }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                { staticClass: "ml-2" },
                                [
                                  _c("v-col", { attrs: { cols: "11" } }, [
                                    _c(
                                      "div",
                                      [
                                        _c("product-item", {
                                          attrs: {
                                            invoiceItems: _vm.invoiceItems,
                                            isLoading: _vm.pleaseWait,
                                          },
                                          on: {
                                            planRemoved: _vm.invoiceListUpdated,
                                            quantityChange:
                                              _vm.invoiceItemQuantityChange,
                                            toLearner: _vm.toLearner,
                                            planRestored:
                                              _vm.invoiceListItemRetored,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "1" } }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider", {}),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                { staticClass: "ml-2" },
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c("span", [
                                        _c("small", [
                                          _vm._v("Add promotion code"),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      !_vm.showCouponControls
                                        ? _c(
                                            "v-icon",
                                            {
                                              attrs: { small: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.showCouponControls = true
                                                },
                                              },
                                            },
                                            [_vm._v("mdi-chevron-down")]
                                          )
                                        : _c(
                                            "v-icon",
                                            {
                                              attrs: { small: "" },
                                              on: {
                                                click: function ($event) {
                                                  _vm.showCouponControls = false
                                                },
                                              },
                                            },
                                            [_vm._v("mdi-chevron-up")]
                                          ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.showCouponControls
                                ? _c(
                                    "v-row",
                                    { staticClass: "ml-6" },
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "8" } },
                                        [
                                          _c("v-text-field", {
                                            ref: "couponRef",
                                            attrs: {
                                              transition: "scale-transition",
                                              label: "Enter code",
                                              "append-icon": "mdi-arrow-right",
                                              rules: [_vm.isValidCoupon],
                                              outlined: "",
                                              disabled: _vm.pleaseWait,
                                              dense: "",
                                            },
                                            on: {
                                              "click:append": function (
                                                $event
                                              ) {
                                                return _vm.applyCoupon()
                                              },
                                            },
                                            nativeOn: {
                                              keyup: function ($event) {
                                                if (
                                                  !$event.type.indexOf("key") &&
                                                  _vm._k(
                                                    $event.keyCode,
                                                    "enter",
                                                    13,
                                                    $event.key,
                                                    "Enter"
                                                  )
                                                )
                                                  return null
                                                return _vm.applyCoupon()
                                              },
                                            },
                                            model: {
                                              value: _vm.coupon,
                                              callback: function ($$v) {
                                                _vm.coupon = $$v
                                              },
                                              expression: "coupon",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-col", { attrs: { cols: "4" } }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showCouponControls &&
                              _vm.couponDescription &&
                              !this.couponError
                                ? _c(
                                    "v-row",
                                    { staticClass: "mt-n12 ml-7" },
                                    [
                                      _c("v-col", { attrs: { cols: "8" } }, [
                                        _c("span", [
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(_vm.couponDescription)
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                { staticClass: "ml-2" },
                                [
                                  _c("v-col", [
                                    _c("span", [_vm._v("Card information")]),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                { staticClass: "ml-6 mt-n4" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "11" } },
                                    [
                                      _c("payment-method", {
                                        attrs: {
                                          stripeKey: _vm.stripeKey,
                                          stripeOptions: _vm.stripeOptions,
                                          elementsOptions: _vm.elementsOptions,
                                          cardOptions: _vm.cardOptions,
                                          loggedUser: _vm.loggedUser,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-col", { attrs: { cols: "1" } }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mt-4 d-inline d-sm-inline d-md-none d-lg-none d-xl-none",
                                },
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c("v-col", { attrs: { cols: "1" } }),
                                      _vm._v(" "),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "10",
                                            align: "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "entity-button-text",
                                              attrs: {
                                                block: "",
                                                color: "secondary",
                                                disabled: _vm.disableCheckout,
                                              },
                                              on: { click: _vm.doUpgradePlan },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Confirm\n                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-col", { attrs: { cols: "1" } }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        {
                          staticClass:
                            "d-none d-sm-none d-md-inline d-lg-inline d-xl-inline",
                          attrs: { cols: "5" },
                        },
                        [
                          _vm.stripeEstimates
                            ? _c(
                                "v-card",
                                {
                                  staticClass: "ml-n8",
                                  attrs: {
                                    "min-height": "350",
                                    outlined: "",
                                    elevation: "2",
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    { staticClass: "ml-2" },
                                    [
                                      _c("v-col", [
                                        _c(
                                          "span",
                                          { staticClass: "font-weight-bold" },
                                          [_vm._v("Summary")]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider"),
                                  _vm._v(" "),
                                  _vm.showNoChangesMessage
                                    ? _c(
                                        "v-row",
                                        { staticClass: "ml-2 mr-n2" },
                                        [
                                          _c("v-col", [
                                            _vm._v(
                                              "\n                  No changes\n                "
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _vm.allProductsDeleted
                                    ? _c(
                                        "v-row",
                                        { staticClass: "ml-2 mr-n2" },
                                        [
                                          _c("v-col", [
                                            _vm._v(
                                              "\n                  Schedule to cancel on " +
                                                _vm._s(_vm.endDate) +
                                                "\n                "
                                            ),
                                          ]),
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        [
                                          _vm.showDetails
                                            ? _c(
                                                "v-row",
                                                { staticClass: "ml-2 mr-n2" },
                                                [
                                                  _c(
                                                    "v-col",
                                                    [
                                                      _c(
                                                        "v-card",
                                                        {
                                                          attrs: {
                                                            color: "#D1D0CE",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-row",
                                                            {
                                                              staticClass:
                                                                "ml-2 mr-n2",
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "8",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-bold",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Prorated credit:"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "4",
                                                                    align:
                                                                      "end",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.proratedCredit
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.proratedCharge
                                                            ? _c(
                                                                "v-row",
                                                                {
                                                                  staticClass:
                                                                    "mt-n7 ml-2 mr-n2",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "8",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-bold",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Prorated charge:"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "4",
                                                                        align:
                                                                          "end",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.proratedCharge
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _c(
                                                                "v-row",
                                                                {
                                                                  staticClass:
                                                                    "mt-n7 ml-2 mr-n2",
                                                                },
                                                                [
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "8",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "text-bold",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Recurring charges:"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "v-col",
                                                                    {
                                                                      attrs: {
                                                                        cols: "4",
                                                                        align:
                                                                          "end",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.getTotalRecurringEstimate
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-row",
                                                            {
                                                              staticClass:
                                                                "mt-n7 ml-2 mr-n2",
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "8",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "text-bold",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "Subtotal:"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "4",
                                                                    align:
                                                                      "end",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.getTotalImmediateEstimate
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-row",
                                                            {
                                                              staticClass:
                                                                "mt-n4 ml-2 mr-n2",
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "8",
                                                                  },
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "Estimate tax"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  attrs: {
                                                                    cols: "4",
                                                                    align:
                                                                      "end",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.taxAmount
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-row",
                                            { staticClass: "ml-2 mr-n2" },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "8" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "text-bold",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Amount due today:"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: {
                                                    cols: "4",
                                                    align: "end",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getTotalImmediateEstimateWithTax
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          !_vm.isDowngrade
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass:
                                                    "mt-n7 mt-n6 ml-2 mr-n2",
                                                },
                                                [
                                                  _c("v-col", [
                                                    !_vm.showDetails
                                                      ? _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: "#",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                _vm.showDetails = true
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("span", [
                                                              _c("small", [
                                                                _vm._v(
                                                                  "Show details"
                                                                ),
                                                              ]),
                                                            ]),
                                                          ]
                                                        )
                                                      : _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: "#",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                _vm.showDetails = false
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("span", [
                                                              _c("small", [
                                                                _vm._v(
                                                                  "Hide details"
                                                                ),
                                                              ]),
                                                            ]),
                                                          ]
                                                        ),
                                                  ]),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.isDowngrade
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass:
                                                    "mt-n4 ml-2 mr-n2",
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "8" } },
                                                    [
                                                      _vm._v(
                                                        "\n                  What you'll pay starting\n                "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "4",
                                                        align: "end",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm.getTotalRecurringEstimate
                                                          ) +
                                                          "\n                "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.isDowngrade
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass:
                                                    "mt-n7 mt-n6 ml-2 mr-n2",
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "8" } },
                                                    [
                                                      _c("span", [
                                                        _c("small", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.newSubscriptionStartDate
                                                            )
                                                          ),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "4",
                                                        align: "end",
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _c("small", [
                                                          _vm._v("(plus tax)"),
                                                        ]),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isDowngrade
                                            ? _c("v-divider")
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.isDowngrade
                                            ? _c(
                                                "v-row",
                                                {
                                                  staticClass:
                                                    "ml-2 mr-n2 secondary--text text-h5 text-bold",
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "7" } },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          "Recurring charges"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      attrs: {
                                                        cols: "5",
                                                        align: "end",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-no-wrap",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.getTotalRecurringEstimate
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                ],
                                1
                              )
                            : _c(
                                "v-card",
                                {
                                  staticClass: "ml-n8",
                                  attrs: { outlined: "", elevation: "2" },
                                },
                                [
                                  _vm.subscriptionCancelled
                                    ? _c("div", [
                                        _vm.hasScheduledDowngrade
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "v-row",
                                                  { staticClass: "ml-2" },
                                                  [
                                                    _c("v-col", [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold",
                                                        },
                                                        [_vm._v("Summary")]
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-divider"),
                                                _vm._v(" "),
                                                _c(
                                                  "v-row",
                                                  { staticClass: "ml-2 mr-n2" },
                                                  [
                                                    _c("v-col", [
                                                      _vm._v(
                                                        "\n                        Downgrade scheduled for " +
                                                          _vm._s(
                                                            _vm.getSubscriptionEndDate
                                                          ) +
                                                          " to " +
                                                          _vm._s(
                                                            _vm.newCountMessage
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "v-row",
                                              { staticClass: "ml-2" },
                                              [
                                                _c("v-col", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "font-weight-bold",
                                                    },
                                                    [_vm._v("Summary")]
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("v-divider"),
                                            _vm._v(" "),
                                            _c(
                                              "v-row",
                                              { staticClass: "ml-2 mr-n2" },
                                              [
                                                _c("v-col", [
                                                  _vm._v(
                                                    "\n                        Scheduled to cancel on " +
                                                      _vm._s(
                                                        _vm.getSubscriptionEndDate
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _c(
                                        "div",
                                        [
                                          _c(
                                            "v-sheet",
                                            {
                                              attrs: {
                                                color: "grey lighten-4",
                                              },
                                            },
                                            [
                                              _c("v-skeleton-loader", {
                                                staticClass: "mx-auto",
                                                attrs: {
                                                  "min-height": "350",
                                                  type: "card-heading, divider, list-item, list-item, list-item, list-item, divider, list-item",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                ]
                              ),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            { staticClass: "mt-10" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ml-n8",
                                  attrs: { align: "end" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "entity-button-text",
                                      attrs: {
                                        outlined: "",
                                        color: "secondary",
                                        disabled: _vm.pleaseWait,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.previousState()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Cancel\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.allProductsDeleted
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "entity-button-text",
                                          attrs: {
                                            color: "secondary",
                                            disabled: _vm.disableCheckout,
                                          },
                                          on: { click: _vm.cancelSubscription },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  Schedule cancellation\n                "
                                          ),
                                        ]
                                      )
                                    : _vm.hasScheduledDowngrade
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "entity-button-text",
                                          attrs: { color: "secondary" },
                                          on: { click: _vm.cancelDowngrade },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { left: "" } },
                                            [
                                              _vm._v(
                                                "\n                        mdi-undo\n                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                  Undo downgrade\n                "
                                          ),
                                        ],
                                        1
                                      )
                                    : !_vm.isDowngrade ||
                                      _vm.showNoChangesMessage
                                    ? _c(
                                        "v-btn",
                                        {
                                          staticClass: "entity-button-text",
                                          attrs: {
                                            color: "secondary",
                                            disabled: _vm.disableCheckout,
                                          },
                                          on: { click: _vm.doUpgradePlan },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Confirm\n                "
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "v-btn",
                                        {
                                          staticClass: "entity-button-text",
                                          attrs: {
                                            color: "secondary",
                                            disabled: _vm.disableCheckout,
                                          },
                                          on: { click: _vm.doUpgradePlan },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Schedule downgrade\n                "
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-progress-linear", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.pleaseWait,
                        expression: "pleaseWait",
                      },
                    ],
                    staticClass: "ma-0",
                    staticStyle: {
                      height: "3px",
                      position: "absolute",
                      bottom: "0",
                    },
                    attrs: { indeterminate: true },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.plansDialog
        ? _c(
            "v-dialog",
            {
              attrs: { scrollable: "", "max-width": "580px" },
              model: {
                value: _vm.plansDialog,
                callback: function ($$v) {
                  _vm.plansDialog = $$v
                },
                expression: "plansDialog",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dense: "" } },
                    [
                      _c("v-toolbar-title", [_vm._v("Select plans to add")]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.plansDialog = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticStyle: { height: "300px" } },
                    [
                      _c("v-simple-table", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function () {
                                return [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", { staticClass: "text-left" }, [
                                        _vm._v(
                                          "\n                  Plan\n                "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("th", { staticClass: "text-left" }, [
                                        _vm._v(
                                          "\n                  Unit price\n                "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.availablePlans,
                                      function (plan, i) {
                                        return _c("tr", { key: i }, [
                                          _c(
                                            "td",
                                            [
                                              _c("v-checkbox", {
                                                staticClass: "mt-2",
                                                attrs: {
                                                  dense: "",
                                                  label: plan.productName,
                                                  value: plan,
                                                  disabled: plan.disabled,
                                                },
                                                model: {
                                                  value: _vm.selectedPlans,
                                                  callback: function ($$v) {
                                                    _vm.selectedPlans = $$v
                                                  },
                                                  expression: "selectedPlans",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatPrice(plan.unitPrice)
                                              ) +
                                                "/" +
                                                _vm._s(plan.interval)
                                            ),
                                          ]),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1384071803
                        ),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "entity-button-text",
                          attrs: {
                            color: "secondary",
                            block: "",
                            disabled: _vm.selectedPlans.length == 0,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addPlans()
                            },
                          },
                        },
                        [_vm._v("\n          Add\n        ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }